export const dashboardFolder =
  'https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/dashboard';
